import styled from "styled-components";
import { deviceSizesMin } from "../../DeviceSizes";

export const SiteHeader = styled.header`
  position: fixed;
  width: 100vw;
  top: 0;
  left: 0;
  z-index: 999;

  background: white;
`;

export const SiteLogoContainer = styled.a`
  padding: 0 18px;
  font-weight: bolder;
  letter-spacing: 1.25px;
  line-height: 26px;
  align-items: center;
  justify-content: center;
  display: flex;
  text-transform: uppercase;
  text-decoration: none;
  color: black;

  top: calc(50% - 36px);

  height: 100%;

  @media only screen and ${deviceSizesMin.laptop} {
    font-size: 12px;
  }

  @media only screen and ${deviceSizesMin.laptopL} {
    font-size: 16px;
  }
`;

export const SiteLogo = styled.img`
  width: 50px;
  margin-right: 10px;
  padding-bottom: 2px;
`;

export const SiteMenu = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e7eaee;
  height: 72px;
  padding: 0 16px;

  @media only screen and ${deviceSizesMin.laptopL} {
    padding: 0 32px;
  }
`;

export const SiteMenuLinks = styled.nav`
  width: 100vw;
  height: calc(100vh - 72px);
  position: absolute;
  top: 72px;
  visibility: ${(props) => (props.showMobileMenu ? "visible" : "hidden")};
  left: ${(props) => (props.showMobileMenu ? "0" : "100vw")};
  transition: left 1s, visibility 1s;
  background-color: #ffffff;
  overflow: scroll;

  @media only screen and ${deviceSizesMin.laptop} {
    overflow: inherit;
    visibility: visible;
    left: auto;
    position: relative;
    width: auto;
    height: 100%;
    top: 0;

    order: 2;
    margin-right: auto;
  }

  @media only screen and ${deviceSizesMin.laptopL} {
    margin-left: 45px;
  }
`;

export const SiteMenuDropdown = styled.div`
  order: 2;
  flex-direction: column;

  @media only screen and (min-width: 992px) {
    display: flex;
    flex-direction: row;
  }
`;

export const HamburgerButton = {
  Wrapper: styled.button`
    height: 3rem;
    width: 2rem;
    position: relative;
    font-size: 12px;
    display: block;

    /* Remove default button styles */
    border: none;
    background: transparent;
    outline: none;

    cursor: pointer;

    &:after {
      content: "";
      display: block;
      position: absolute;
      height: 150%;
      width: 150%;
      top: -25%;
      left: -25%;
    }

    @media only screen and ${deviceSizesMin.laptop} {
      display: none;
    }
  `,
  Lines: styled.div`
    top: 50%;
    margin: -0.125em auto;

    &,
    &:after,
    &:before {
      height: 3px;
      pointer-events: none;
      display: block;
      content: "";
      width: ${(props) => (props.active ? "75%" : "100%")};
      background-color: black;
      position: absolute;
    }

    & {
      background-color: ${(props) => (props.active ? "white" : "black")};
      margin-left: ${(props) => (props.active ? "7px" : "0")};
    }

    &:after {
      top: ${(props) => (props.active ? "0" : "-0.5rem")};

      transform: ${(props) => (props.active ? "skewY(45deg)" : "none")};
      transition: transform, 0.2s;
    }

    &:before {
      top: ${(props) => (props.active ? "0" : "0.5rem")};

      transform: ${(props) => (props.active ? "skewY(-45deg)" : "none")};
      transition: transform, 0.2s;
    }
  `,
};
